/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */

import {Component, Vue} from 'vue-property-decorator';

/**
 * Scroller mixin provides default page scroller functionality.
 * @author Jonny Cook <jcook@frontier.co.uk>
 */
@Component
export default class Scroller extends Vue {
    /**
     * Scroll the page to the top.
     */
    public scrollTop(position: number = 0): void {
        if (window.scrollY !== position) {
            window.scrollTo({
                top: position,
                behavior: 'smooth',
            });

            window.addEventListener('scroll', function handler(): void {
                if (window.scrollY < 100) {
                    window.removeEventListener('scroll', handler);
                }
            });
            return;
        }
    }
}

